import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleRanklist = {
  namespaced: true,

  state: {
    name: "ranklist",
    ranklist: [],
  },

  mutations,
  getters,
  actions,
};

export default moduleRanklist;
